<template>

    <div class="img_box_box" v-if="visible" @click="visible = false">
        <div class="img_box">
            <img src="../assets/xcxCode.png">
        </div>
    </div>

</template>


<script>
export default {
    data() {
        return {
            visible:false
        }
    },
    methods:{
        init(){
            debugger
            this.visible = true
        }
    }
}

</script>

<style lang="scss" scoped>
    .img_box_box{
        position:fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.6);
        .img_box{
            margin: 200px auto;
            text-align: center;
            img{
                width: 300px;
            }
        }
    }
</style>